<template>
    <div class="navbar" :class="{'is-hidden-menu': !isShowMenu}">
        <!-- <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb class="breadcrumb-container" /> -->
        <!-- park name -->
        <!-- <span class="header-title-name">
            {{parkName}}
        </span> -->
        <span v-if="!isShowMenu || isPersonal" class="header-logo main-logo" @click="handlerGo('homeGuide')">
            <img :src="logoHref" alt="">
        </span>
        <!-- Logo -->
        <span v-else class="header-logo">
            <img :src="logo" alt="">
        </span>
        <!-- menu -->
        <siderBar v-if="isShowMenu && !isPersonal" style="overflow: hidden" />
        <p v-else class="header-menu-empty" style="min-width: 660px"></p>
        <!-- right btn -->
        <div v-if="isShowMenu" class="right-menu">
            <span class="menu-item-btn" v-if="!isPersonal" style="display:block;position: relative">
                <span class="item-icon-box">
                    <i class="home-icon-search" @click="handlerSearch"></i>
                </span>
                <el-input v-if="showSearch" v-model="headerInput" class="header-input" placeholder="搜索关键词…" @keyup.enter.native="handlerEnsureSearch">
                    <el-button slot="append" icon="el-icon-search" @click="handlerEnsureSearch">搜索</el-button>
                </el-input>
            </span>
            <span class="menu-split" v-if="!isPersonal"></span>
            <span class="menu-item-btn user-box" style="display:block;position: relative;">
                <span class="item-icon-box">
                    <i class="home-icon-user" @click="handlerGo('login')">
                    </i>
                </span>
                <!-- <ul v-if="!isLogin" class="home-user-poper">
                    <span class="poper-icon"></span>
                    <li class="poper-item">
                        <span class="item-btn" @click="handlerGo('register')">我要注册</span>
                    </li>
                    <li class="poper-item">
                        <span class="item-btn" @click="handlerGo('login')">登录</span>
                    </li>
                </ul> -->
                <ul v-if="isLogin" class="home-user-poper">
                    <span class="poper-icon"></span>
                    <li class="poper-item">
                        <span class="item-btn" @click="handlerGo('personal')">个人中心</span>
                    </li>
                    <li class="poper-item">
                        <span class="item-btn" @click="handlerGo('logout')">退出</span>
                    </li>
                </ul>
            </span>
            <span class="menu-split"></span>
            <span class="menu-item-btn home-box" style="display:block;">
                <span class="item-icon-box" style="background: transparent !important">
                    <i class="home-icon-home" @click="handlerGo('homeGuide')" @mouseover="showBackTips = true" @mouseout="showBackTips = false"></i>
                </span>
                <span v-if="showBackTips" class="home-back-tips">返回首页</span>
                <el-tooltip content="国家公园主页" placement="right" effect="light">
                </el-tooltip>
                <!-- <ul class="home-user-poper">
                    <span class="poper-icon"></span>
                    <li class="poper-item">
                        <span class="item-btn" @click="handlerGo('homeGuide')">国家公园主页</span>
                    </li>
                </ul> -->
            </span>
            <!-- <span style="display:block;">登录/</span>
            <span style="display:block;">注册</span> -->
            <!-- <el-dropdown class="avatar-container" trigger="click">
                <div class="avatar-wrapper">
                    <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
                    <i class="el-icon-caret-bottom" />
                </div>
                <template v-slot:dropdown>
                    <el-dropdown-menu class="user-dropdown">
                        <router-link to="/">
                            <el-dropdown-item>
                                Home
                            </el-dropdown-item>
                        </router-link>
                        <a target="_blank" href="https://github.com/PanJiaChen/vue-admin-template/">
                            <el-dropdown-item>Github</el-dropdown-item>
                        </a>
                        <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
                            <el-dropdown-item>Docs</el-dropdown-item>
                        </a>
                        <el-dropdown-item divided @click.native="logout">
                            <span style="display:block;">Log Out</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
// import Hamburger from '@/components/Hamburger'
import siderBar from './Sidebar'
import Cookies from 'js-cookie'
import { logOut } from '@/api/login'

export default {
    components: {
        siderBar
        // Hamburger
    },
    computed: {
        ...mapGetters([
            'sidebar',
            'avatar',
            'token'
        ]),
        parkName() {
            return this.$store.state.user.activeParkName
        },
        isPersonal() {
            return this.$route.path.startsWith('/personalIndex')
        }
    },
    watch: {
        'token': {
            handler: function (val) {
                if (val) {
                    //
                } else {
                    this.isLogin = false
                }
            },
            immediate: true
        },
        '$route': {
            handler(val) {
                if (this.$route.path === '/loginIndex') {
                    this.isShowMenu = false
                } else {
                    this.isShowMenu = true
                }
            }
        }
    },
    data() {
        return {
            // parkName: '武夷山国家公园',
            logoHref: require("@/assets/guide/home_logo.jpg"),
            headerInput: '',
            logoList: [
                { id: 1003, parkLogo: require("@/assets/guide/1003_parkLogo.png") },
                { id: 1004, parkLogo: require("@/assets/guide/1004_parkLogo.png") },
                { id: 1005, parkLogo: require("@/assets/guide/1005_parkLogo.png") },
                { id: 1002, parkLogo: require("@/assets/guide/1002_parkLogo.png") },
                { id: 1006, parkLogo: require("@/assets/guide/1006_parkLogo.png") },
                { id: 1007, parkLogo: require("@/assets/guide/1007_parkLogo.png") },
                { id: 1008, parkLogo: require("@/assets/guide/1008_parkLogo.png") },
                { id: 1001, parkLogo: require("@/assets/guide/1001_parkLogo.jpg") },
                { id: 1010, parkLogo: require("@/assets/guide/1010_parkLogo.png") },
                { id: 1009, parkLogo: require("@/assets/guide/1009_parkLogo.png") },
            ],
            logo: '',
            showSearch: false,
            isLogin: false,
            showBackTips: false,
            isShowMenu: true
        }
    },
    mounted() {
        if (this.$route.path === '/loginIndex') {
            this.isShowMenu = false
        }
        // this.toggleSideBar()
        Cookies.set('sidebarStatus', 1)
        if (this.token) {
            this.isLogin = true
        }
        // let _parkName = localStorage.getItem('activeParkName')
        // this.parkName = _parkName
        let _parkId = localStorage.getItem('activeParkId')
        if (_parkId) {
            let _logo = this.logoList.filter(item => item.id === parseInt(_parkId))
            if (_logo && _logo[0] && _logo[0].parkLogo) {
                this.logo = _logo[0].parkLogo
            }
        }
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar')
        },
        async logout() {
            await this.$store.dispatch('user/logout')
            this.$router.push(`/login?redirect=${this.$route.fullPath}`)
        },
        handlerSearch() {
            this.showSearch = !this.showSearch
            // this.$router.push({
            //     name: 'Login'
            // })
        },
        handlerEnsureSearch() {
            if (this.headerInput) {
                this.showSearch = false
                let _origin = window.location.origin
                let _pathName = window.location.pathname
                window.open(`${_origin}${_pathName}#/search?keyword=${this.headerInput}`, "_blank")
                // this.$router.push({
                //     name: 'Search',
                //     query: {
                //         keyword: this.headerInput
                //     }
                // })
            }
        },
        handlerGo(t) {
            let _currentRoute = this.$route.name
            switch (t) {
                case 'login':
                    if (_currentRoute === 'LoginIndex') {
                        if (window.location.hash.includes('register')) {
                            window.location.hash = '#/loginIndex?type=login'
                            // window.location.reload()
                        }
                        return false
                    }
                    // 已登录
                    if (this.isLogin) {
                        return false
                    }
                    this.$router.push({
                        name: 'Login',
                        query: {
                            type: 'login'
                        }
                    })
                    break;
                case 'register':
                    this.$router.push({
                        name: 'Login',
                        query: {
                            type: 'register'
                        }
                    })
                    break;
                case 'logout':
                    logOut().then(res => {
                        if (res) {
                            this.$store.dispatch('user/resetToken')
                            // localStorage.removeItem('authorAccessToken')
                            this.$router.push({
                                name: 'Login',
                                query: {
                                    type: 'login'
                                }
                            })
                        }
                    })
                    break;
                case 'personal':
                    if (_currentRoute === 'PersonalIndex') {
                        return false
                    }
                    this.$router.push({
                        name: 'Personal'
                    })
                    break;
                case 'homeGuide':
                    this.$router.push({
                        path: '/'
                    })
                    break;
                default:
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.navbar {
    height: 60px;
    // overflow: hidden;
    position: relative;
    // background: #fff;
    color: #fff;
    // box-shadow: 0 1px 4px rgba(0,21,41,.08);
    display: flex;
    justify-content: space-between;
    // padding-left: 20px;
    margin-bottom: 1px;
    border: none !important;
    z-index: 5;
    &.is-hidden-menu{
        justify-content: start;
        .header-logo{
            margin-left: 50px !important;
            cursor: pointer;
        }
    }

    .header-title-name {
        width: 260px;
        // height: 28px;
        font-size: 30px;
        font-family: MicrosoftYaHei, PingFangSC;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 60px;
        overflow: hidden;
    }

    .header-logo {
        width: 345px;

        img {
            max-width: 100%;
            width: 345px;
            height: 100%;
        }
        &.main-logo{
            width: 224px;
            img{
                height: 60px;
                width: 100%;
            }
        }
    }

    .hamburger-container {
        line-height: 46px;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background 0.3s;
        -webkit-tap-highlight-color: transparent;

        &:hover {
            background: rgba(0, 0, 0, 0.025);
        }
    }

    .breadcrumb-container {
        float: left;
    }

    .header-input {
        // float: left;
        // line-height: 60px;
        margin-right: 10px;
        // max-width: 200px;
        position: absolute;
        top: 72px;
        right: -50px;
        width: 292px;

        ::v-deep .el-input__inner {
            background-color: #FFFFFF !important;
            border: 1px solid #cccccc !important;
            // color: #707070;
            font-size: 12px;
            border-radius: 15px 0 0 15px;
        }

        ::v-deep .el-input__inner::placeholder {
            color: #707070;
        }

        /* 谷歌 */
        .el-input__inner::-webkit-input-placeholder {
            color: #707070;
        }

        ::v-deep .el-input-group__append {
            border-radius: 0px 15px 15px 0px;
            border-color: #50A088;
            background: #50A088;

            .el-button {
                background: #50A088;
                border-radius: 0px 15px 15px 0px;
                font-size: 12px;
                font-family: MicrosoftYaHei, PingFangSC;
                font-weight: normal;
                color: #FFFFFF;
            }
        }
    }

    .right-menu {
        float: right;
        height: 100%;
        line-height: 60px;
        padding-right: 20px;
        display: flex;
        justify-content: center;

        &:focus {
            outline: none;
        }

        .menu-item-btn {
            // line-height: 68px;
            // padding: 0 10px;
            margin: 0 2px;
            width: 35px;
            .item-icon-box{
                padding: 8px;
                    .home-icon-search{
                        cursor: pointer;
                        &:hover{
                            background: url("@/assets/header/header-search-hover.png") no-repeat center;
                            background-size: 100% 100%;
                        }
                    }
            }
            &.user-box {
                position: relative;
                cursor: pointer;
                &:hover {
                    .home-icon-user{
                        background: url("@/assets/header/header-user-hover.png") no-repeat center;
                        background-size: 100% 100%;
                    }
                    .home-user-poper {
                        display: block;
                    }
                }
            }

            &.home-box {
                position: relative;
                .item-icon-box {
                    .home-icon-home {
                        &:hover {
                            background: url("@/assets/header/header-home-hover.png") no-repeat center;
                            background-size: 100% 100%;
                        }
                    }
                    .home-back-tips{
                        display: inline-block;
                    }
                }
            }
        }

        .menu-split {
            display: inline-block;
            width: 1px;
            height: 32%;
            border-radius: 4px;
            background: #FFFFFF;
            margin-top: 21px;
            margin-left: 7px;
            margin-right: 7px;
            opacity: 0.5;
        }

        .home-icon-search {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: url("@/assets/header/search@2x.png") no-repeat center;
            background-size: 100% 100%;
            transform: translateY(4px);
        }

        .home-user-poper {
            display: none;
            position: absolute;
            top: 60px;
            margin: 0;
            width: 90px;
            list-style: none;
            padding: 9px 0;
            background: #50a088;
            left: -29px;
            border-radius: 0px 0px 6px 6px;

            .poper-icon {
                position: relative;

                &::before {
                    width: 0;
                    height: 0;
                    display: block;
                    content: "";
                    border: 9px solid transparent;
                    border-top: 6px solid transparent;
                    border-top-color: #208060;
                    left: 50%;
                    position: absolute;
                    top: -9px;
                    margin-left: -9px;
                }
            }

            .poper-item {
                height: 30px;
                line-height: 30px;

                .item-btn {
                    display: inline-block;
                    padding: 6px 10px;
                    border-radius: 6px;
                    font-size: 12px;
                    line-height: 1;
                    width: 72px;
                    font-family: MicrosoftYaHei, PingFangSC;

                    &:hover {
                        background: #FFFFFF;
                        color: #50a088;
                    }
                }
            }
        }

        .home-icon-user {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: url("@/assets/header/user@2x.png") no-repeat center;
            background-size: 100% 100%;
            transform: translateY(4px);
        }

        .home-icon-home {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: url("@/assets/header/home@2x.png") no-repeat center;
            background-size: 100% 100%;
            transform: translateY(4px);
            cursor: pointer;
        }
        .home-back-tips{
            // display: none;
            font-family: SourceHanSerifCN-Bold;
            width: 62px;
            position: absolute;
            height: 100%;
            line-height: 58px;
            font-size: 12px;
            cursor: default;
        }

        .right-menu-item {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;

            &.hover-effect {
                cursor: pointer;
                transition: background 0.3s;

                &:hover {
                    background: rgba(0, 0, 0, 0.025);
                }
            }
        }

        .avatar-container {
            margin-right: 30px;

            .avatar-wrapper {
                margin-top: 5px;
                position: relative;

                .user-avatar {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }

                .el-icon-caret-bottom {
                    cursor: pointer;
                    position: absolute;
                    right: -20px;
                    top: 25px;
                    font-size: 12px;
                }
            }
        }
    }
    .header-menu-empty{
        min-width: 642px;
    }
}

@media screen and (min-width: 1920px) {
    .navbar {
        height: 80px;

        .header-title-name {
            width: 260px;
            // height: 28px;
            font-size: 40px;
            font-family: MicrosoftYaHei, PingFangSC;
            font-weight: normal;
            color: #FFFFFF;
            line-height: 80px;
            overflow: hidden;
        }

        .header-logo {
            width: 460px;

            img {
                max-width: 100%;
                width: 460px;
                height: 100%;
            }
            &.main-logo{
                width: 298px;
                img{
                    height: 80px;
                    width: 100%;
                }
            }
        }
        .header-input {
            top: 92px !important;
            width: 389px !important;
            ::v-deep .el-input__inner {
                background-color: #FFFFFF !important;
                border: 1px solid #cccccc !important;
                // color: #707070;
                font-size: 16px;
                border-radius: 24px 0 0 24px;
            }

            ::v-deep .el-input__inner::placeholder {
                color: #707070;
            }

            /* 谷歌 */
            .el-input__inner::-webkit-input-placeholder {
                color: #707070;
            }

            ::v-deep .el-input-group__append {
                border-radius: 0px 24px 24px 0px;
                border-color: #50A088;
                background: #50A088;

                .el-button {
                    background: #50A088;
                    border-radius: 0px 24px 24px 0px;
                    font-size: 16px;
                    font-family: MicrosoftYaHei, PingFangSC;
                    font-weight: normal;
                    color: #FFFFFF;
                }
            }
        }
        .right-menu {
            .menu-item-btn {
                line-height: 80px;
                width: 56px;
                .item-icon-box{
                    padding: 14px 12px;
                }
            }

            .menu-split {
                margin-top: 28px;
            }

            .home-icon-search {
                width: 24px;
                height: 24px;
                transform: translateY(6px);
            }

            .home-icon-user {
                width: 24px;
                height: 24px;
                transform: translateY(6px);
            }

            .home-icon-home {
                width: 24px;
                height: 24px;
                transform: translateY(6px);
            }
            .home-back-tips{
                // display: inline-block;
                width: 71px;
                // position: absolute;
                height: 100%;
                line-height: 80px;
                font-size: 16px;
                cursor: default;
            }

            .home-user-poper {
                top: 80px;
                left: -17px;
            }
        }
        .header-menu-empty{
            min-width: 696px !important;
        }
    }
}
</style>
